<template>
    <div class="mb-3">
        <label class="form-label">Option Groups</label>
        <div class="form-row row mb-3">
            <div class="form-group col-4">
                <input type="text" class="form-control" v-model="this.name" placeholder="New Group Name">
            </div>
            <div class="form-group col-4">
                <button type="button" @click="CreateGroup()" class="btn btn-warning">Create Group</button>
            </div>
        </div>
    </div>

    <div class="mb-3 option-groups-container">

        <div v-for="(group, a) in groups" class="bg-alt-yellow mb-3 extra-rounded p-3 option-group-container" >

            <div style="display: flex; align-items: center; justify-content: space-between;">
                <label class="form-label">{{ group.name }} Options</label>

                <div class="flex-x center-x">
                    <label class="form-label mx-2 my-0">Update Name</label>
                    <input type="text" :name="`group[${a}]`" :value="`${ group.name ?? '' }`">
                </div>

                <input type="hidden" :name="`group_id[${a}]`" :value="`${ group.id ?? '' }`">
                <button type="button" class="btn btn-warning delete-group-button">Delete Group</button>
            </div>

            <div class="options-container my-2">
                <div v-for="(option, b) in group.options" class="flex-x center-x option-container mb-3">
                    <input type="hidden" :name="`option_id[${a}][${b}]`" :value="`${ option.id ?? '' }`">
                    <label class="form-label">Name</label>
                    <input type="text" class="form-control mx-2" style="width: 160px;" :name="`option_name[${a}][${b}]`" :value="`${ option.name ?? '' }`">
                    <label class="form-label mx-2">Price Modifier</label>
                    <input type="number" class="form-control mx-2" style="width: 160px;" :name="`option_price[${a}][${b}]`" :value="`${ option.price_modifier ?? '' }`">
                    <button type="button" class="btn btn-warning" @click="DeleteOption(option.id, group.id)">Delete Option</button>
                </div>
            </div>

            <button type="button" @click="AddOption(group.id, a)" class="btn btn-warning">Add Option</button>

        </div>

    </div>

</template>

<script>
export default {

    data () {
        return {
            groups: [],
            name: ""
        }
    },

    props: ['items'],

    created () {
        this.groups = this.items;
    },

    methods: {

        CreateGroup () {
            if ( this.name == "" ) return;
            this.groups.push({ name: this.name, options: [] });
            this.name = "";
        },

        AddOption ( id ) {
            var group = this.groups.find( a => a.id == id );
            group.options.push({})
        },

        async DeleteGroup ( id ) {
            const response = await axios.post(`/admin/item/delete/group`, { id: id });
            const key = this.groups.findIndex(a => a.id == id);
            this.groups.splice(key, 1);
            window.Toast('Option Group has been deleted')
        },

        async DeleteOption ( id, group_id ) {
            const response = await axios.post(`/admin/item/delete/option`, { id: id });
            const group = this.groups.find(a => a.id == group_id);
            const key = group.options.findIndex(b => b.id == id);
            group.options.splice(key, 1);
            window.Toast('Option has been deleted')
        }

    }

}
</script>